import _ from 'lodash';

import {
  BookingState,
  ADD_BOOKING,
  GET_ACTIVE_BOOKING_TYPES,
  GET_ACTIVE_BOOKING_TYPES_SUCCESS,
  GET_ACTIVE_BOOKING_TYPES_FAILURE,
  GET_BOOKING,
  GET_BOOKING_STATUS,
  GET_BOOKING_CALCULATE,
  GET_PENDING_BOOKING,
  GET_PENDING_BOOKING_SUCCESS,
  GET_ALL_BOOKING,
  GET_ALL_BOOKING_SUCCESS,
  GET_ACTIVE_BOOKING,
  GET_ACTIVE_BOOKING_SUCCESS,
  GET_BOOKING_SUCCESS,
  GET_BOOKING_CALCULATE_SUCCESS,
  GET_BOOKING_CALCULATE_FAILURE,
  UPDATE_BOOKING_STATUS,
  UPDATE_BOOKING_STATUS_SUCCESS,
  UPDATE_BOOKING_STATUS_FAILURE,
  CANCEL_BOOKING, CANCEL_BOOKING_SUCCESS, CANCEL_BOOKING_FAILURE,
  UPLOAD_BOOKING_LICENSE,
  UPLOAD_BOOKING_LICENSE_SUCCESS,
  UPLOAD_BOOKING_LICENSE_FAILURE,
  UPLOAD_BOOKING_AGREEMENT,
  UPLOAD_BOOKING_AGREEMENT_SUCCESS,
  UPLOAD_BOOKING_AGREEMENT_FAILURE,
  UPLOAD_BOOKING_SELFIE_WITH_CAR,
  UPLOAD_BOOKING_SELFIE_WITH_CAR_SUCCESS,
  UPLOAD_BOOKING_SELFIE_WITH_CAR_FAILURE,
  UPLOAD_BOOKING_ADDRESS_PROOF,
  UPLOAD_BOOKING_ADDRESS_PROOF_SUCCESS,
  UPLOAD_BOOKING_ADDRESS_PROOF_FAILURE,
  GET_FINAL_AGREEMENT_CHECKLIST,
  GET_FINAL_AGREEMENT_CHECKLIST_SUCCESS,
  GET_FINAL_AGREEMENT_CHECKLIST_FAILURE,
  GET_CHECKIN_IMAGE,
  GET_CHECKIN_IMAGE_SUCCESS,
  GET_CHECKIN_IMAGE_FAILURE,
  UPLOAD_CHECKIN_IMAGE,
  UPLOAD_CHECKIN_IMAGE_SUCCESS,
  UPLOAD_CHECKIN_IMAGE_FAILURE,
  GET_PROGRESS_MESSAGES,
  GET_PROGRESS_MESSAGES_SUCCESS,
  GET_PROGRESS_MESSAGES_FAILURE,
  BOOKING_SUCCESS,
  BOOKING_FAILURE,
  RESET_BOOKING_STATE,

  CREATE_EXTENSION_REQUEST,
  CREATE_EXTENSION_REQUEST_SUCCESS,
  CREATE_EXTENSION_REQUEST_FAILURE,

  BookingActionTypes,
} from "../types/bookingTypes";


const initialState: BookingState = {
  bookingStatusList: null,
  bookings: null,
  activeBookings: { data: [] },
  pendingBookings: { data: [] },
  bookingDetail: null,
  bookingTotalAmount: null,
  bookingDetailLoading: false,
  bookingsLoading: false,
  bookingsSuccess: null,
  bookingsError: null,
  bookingsCalculateError: null,
  bookingTypes: [],
  bookingUploadLicenseLoading: false,
  bookingUploadLicenseSuccess: null,
  bookingUploadLicenseError: null,
  bookingUploadAgreementLoading: false,
  bookingUploadAgreementSuccess: null,
  bookingUploadAgreementError: null,
  bookingDates: [],
  bookingDatesLoading: false,
  bookingDatesSuccess: null,
  bookingDatesError: null,
  pendingBookingsLoading: false,
  pendingBookingsSuccess: null,
  pendingBookingsError: null,
  bookingAddressProofLoading: false,
  bookingAddressProofSuccess: null,
  bookingAddressProofError: null,
  bookingSelfieWithCarLoading: false,
  bookingSelfieWithCarSuccess: null,
  bookingSelfieWithCarError: null,
  bookingCancelLoading: false,
  finalAgreementChecklist: [],
  bookingCancelSuccess: null,
  bookingCancelError: null,
  checkInCarImages: [],
  checkInCarImagesSuccess: null,
  checkInCarImagesError: null,
  checkInCarImagesLoading: false,
  progressMessages: [],

  extensionRequestLoading: false,
  extensionRequestSuccess: null,
  extensionRequestError: null,
  extensionRequest: null,

};

export const bookingReducer = (
  state = initialState,
  action: BookingActionTypes
): BookingState => {
  switch (action.type) {
    case GET_BOOKING: {
      return {
        ...state,
        bookingDetail: [],
        bookingsError: null,
        bookingDetailLoading: true,
      };
    }

    case GET_BOOKING_SUCCESS: {
      return {
        ...state,
        bookingDetail: action.payload?.data,
        bookingsError: null,
        bookingDetailLoading: false,
      };
    }

    case GET_BOOKING_STATUS: {
      return { ...state, bookingStatusList: action.payload?.data };
    }

    case GET_ACTIVE_BOOKING: {
      return {
        ...state,
        activeBookings: [],
        bookingsError: null,
        bookingsLoading: true,
      };
    }
    case GET_ACTIVE_BOOKING_SUCCESS: {
      return {
        ...state,
        activeBookings: action.payload,
        bookingsError: null,
        bookingsLoading: false,
      };
    }

    case GET_ALL_BOOKING: {
      return {
        ...state,
        bookings: [],
        bookingsError: null,
        bookingsLoading: true,
      };
    }

    case GET_ALL_BOOKING_SUCCESS: {
      return {
        ...state,
        bookings: action.payload,
        bookingsError: null,
        bookingsLoading: false,
      };
    }

    case GET_BOOKING_CALCULATE: {
      return {
        ...state,
        bookingTotalAmount: 0,
        bookingsCalculateError: null,
        bookingsLoading: true,
      };
    }

    case GET_BOOKING_CALCULATE_SUCCESS: {
      return {
        ...state,
        bookingTotalAmount: action.payload?.data ?? 0,
        bookingsCalculateError: null,
        bookingsLoading: false,
      };
    }

    case GET_BOOKING_CALCULATE_FAILURE: {
      return {
        ...state,
        bookingsCalculateError: action.payload,
        bookingsLoading: false,
      };
    }

    case UPDATE_BOOKING_STATUS: {
      return { ...state, bookingsError: null, bookingsLoading: true };
    }

    case UPDATE_BOOKING_STATUS_SUCCESS: {
      let updatedBookings = state.bookings?.data || [];
      let updatedPendingBookings = state.pendingBookings?.data || [];
      let updatedActiveBookings = state.activeBookings?.data || [];
      let updatedBookingsMeta = state.bookings?.meta || {};

      if (action.payload?.data?.status_id === "3") {
        updatedBookings = [action.payload.data, ...updatedBookings];

        updatedPendingBookings = updatedPendingBookings.filter(
          (pendingBooking: any) => pendingBooking.id !== action.payload.data.id
        );

        updatedBookingsMeta = {
          ...(state.bookings?.meta ?? {}),
          total_items: Math.max(
            (state.bookings?.meta?.total_items ?? 0) + 1,
            0
          ),
        };
      } else if (action.payload?.data?.status_id === "6") {
        updatedBookings = [action.payload.data, ...updatedBookings];

        updatedActiveBookings = updatedActiveBookings.filter(
          (activeBooking: any) => activeBooking.id !== action.payload.data.id
        );

        updatedBookingsMeta = {
          ...(state.bookings?.meta ?? {}),
          total_items: Math.max(
            (state.bookings?.meta?.total_items ?? 0) + 1,
            0
          ),
        };
      }

      return {
        ...state,
        activeBookings: {
          ...(state.activeBookings ?? {}),
          data: updatedActiveBookings,

        },
        pendingBookings: {
          ...(state.pendingBookings ?? {}),
          data: updatedPendingBookings,
        },
        bookings: {
          ...(state.bookings ?? {}),
          data: updatedBookings,
          meta: updatedBookingsMeta,
        },
        bookingsSuccess: action.payload?.message,
        bookingsError: null,
        bookingsLoading: false,
      };
    }


    case UPDATE_BOOKING_STATUS_FAILURE: {
      return { ...state, bookingsError: action.payload, bookingsLoading: false };
    }

    case CANCEL_BOOKING: {
      return { ...state, bookingCancelError: null, bookingCancelLoading: true };
    }


    case CANCEL_BOOKING_SUCCESS: {
      let updatedBookings = state.bookings?.data || [];
      let updatedPendingBookings = state.pendingBookings?.data || [];
      let updatedActiveBookings = state.activeBookings?.data || [];
      let updatedBookingsMeta = state.bookings?.meta || {};

      if (action.payload?.data?.status_id === "3") {
        updatedBookings = [action.payload.data, ...updatedBookings];

        updatedPendingBookings = updatedPendingBookings.filter(
          (pendingBooking: any) => pendingBooking.id !== action.payload.data.id
        );

        updatedBookingsMeta = {
          ...(state.bookings?.meta ?? {}),
          total_items: Math.max(
            (state.bookings?.meta?.total_items ?? 0) + 1,
            0
          ),
        };
      } else if (action.payload?.data?.status_id === "6") {
        updatedBookings = [action.payload.data, ...updatedBookings];

        updatedActiveBookings = updatedActiveBookings.filter(
          (activeBooking: any) => activeBooking.id !== action.payload.data.id
        );

        updatedBookingsMeta = {
          ...(state.bookings?.meta ?? {}),
          total_items: Math.max(
            (state.bookings?.meta?.total_items ?? 0) + 1,
            0
          ),
        };
      }

      return {
        ...state,
        activeBookings: {
          ...(state.activeBookings ?? {}),
          data: updatedActiveBookings,

        },
        pendingBookings: {
          ...(state.pendingBookings ?? {}),
          data: updatedPendingBookings,
        },
        bookings: {
          ...(state.bookings ?? {}),
          data: updatedBookings,
          meta: updatedBookingsMeta,
        },
        bookingCancelSuccess: action.payload?.message,
        bookingCancelError: null,
        bookingCancelLoading: false,
      };
    }


    case CANCEL_BOOKING_FAILURE: {
      return { ...state, bookingCancelError: action.payload, bookingCancelLoading: false };
    }



    case ADD_BOOKING: {
      return { ...state, bookingsError: null, bookingsLoading: true };
    }

    case BOOKING_SUCCESS: {
      return {
        ...state,
        bookingsSuccess: action.payload?.message,
        bookings: action.payload?.data,
        bookingsError: null,
        bookingsLoading: false,
      };
    }

    case BOOKING_FAILURE: {
      return {
        ...state,
        bookingsError: action.payload,
        bookingsLoading: false,
      };
    }

    case GET_ACTIVE_BOOKING_TYPES: {
      return {
        ...state,
        bookingTypes: [],
        bookingsError: null,
        bookingsLoading: true,
      };
    }

    case GET_ACTIVE_BOOKING_TYPES_SUCCESS: {
      return {
        ...state,
        bookingTypes: action.payload,
        bookingsError: null,
        bookingsLoading: false,
      };
    }

    case GET_ACTIVE_BOOKING_TYPES_FAILURE: {
      return {
        ...state,
        bookingsError: action.payload,
        bookingsLoading: false,
      };
    }

    case UPLOAD_BOOKING_LICENSE: {
      return {
        ...state,
        bookingUploadLicenseError: null,
        bookingUploadLicenseSuccess: null,
        bookingUploadLicenseLoading: true,
      };
    }

    case UPLOAD_BOOKING_LICENSE_SUCCESS: {
      const updatedActiveBookings = Array.isArray(state.activeBookings?.data)
        ? state.activeBookings.data.map((booking: any) =>
          booking.id === action.payload?.data?.id
            ? { ...booking, ...action.payload.data }
            : booking
        )
        : [];

      const updatedPendingBookings = Array.isArray(state.pendingBookings?.data)
        ? state.pendingBookings.data.map((booking: any) =>
          booking.id === action.payload?.data?.id
            ? { ...booking, ...action.payload.data }
            : booking
        )
        : [];

      return {
        ...state,
        activeBookings: {
          ...(state.activeBookings ?? {}),
          data: updatedActiveBookings,
        },
        pendingBookings: {
          ...(state.pendingBookings ?? {}),
          data: updatedPendingBookings,
        },
        bookingUploadLicenseSuccess: action.payload?.message,
        bookingUploadLicenseLoading: false,
      };
    }

    case UPLOAD_BOOKING_LICENSE_FAILURE: {
      return {
        ...state,
        bookingUploadLicenseError: action.payload,
        bookingUploadLicenseLoading: false,
      };
    }

    case UPLOAD_BOOKING_SELFIE_WITH_CAR: {
      return {
        ...state,
        bookingSelfieWithCarError: null,
        bookingSelfieWithCarSuccess: null,
        bookingSelfieWithCarLoading: true,
      };
    }

    case UPLOAD_BOOKING_ADDRESS_PROOF: {
      return {
        ...state,
        bookingAddressProofError: null,
        bookingAddressProofSuccess: null,
        bookingAddressProofLoading: true,
      };
    }

    case UPLOAD_BOOKING_SELFIE_WITH_CAR_SUCCESS: {
      const updatedBookings = state.bookings?.data?.map((booking: any) =>
        booking.id === action.payload?.data?.id
          ? { ...booking, ...action.payload?.data }
          : booking
      );

      const updatedPendingBookings = Array.isArray(state.pendingBookings?.data)
        ? state.pendingBookings.data.map((booking: any) =>
          booking.id === action.payload?.data?.id
            ? { ...booking, ...action.payload.data }
            : booking
        )
        : [];

      return {
        ...state,
        bookingSelfieWithCarSuccess: action.payload?.message,
        bookingSelfieWithCarLoading: false,
        bookings: {
          ...(state.bookings ?? {}),
          data: updatedBookings,
        },

        pendingBookings: {
          ...(state.pendingBookings ?? {}),
          data: updatedPendingBookings,
        },
      };
    }

    case UPLOAD_BOOKING_ADDRESS_PROOF_SUCCESS: {
      const updatedBookings = state.bookings?.data?.data?.map((booking: any) =>
        booking.id === action.payload?.data?.id
          ? { ...booking, ...action.payload.data }
          : booking
      );

      return {
        ...state,
        bookingAddressProofSuccess: action.payload?.message,

        bookings: {
          ...(state.bookings ?? {}),
          data: updatedBookings,
        },
        bookingAddressProofLoading: false,
      };
    }

    case UPLOAD_BOOKING_SELFIE_WITH_CAR_FAILURE: {
      return {
        ...state,
        bookingSelfieWithCarError: action.payload,
        bookingSelfieWithCarLoading: false,
      };
    }

    case UPLOAD_BOOKING_ADDRESS_PROOF_FAILURE: {
      return {
        ...state,
        bookingAddressProofError: action.payload,
        bookingAddressProofLoading: false,
      };
    }

    case UPLOAD_BOOKING_AGREEMENT: {
      return {
        ...state,
        bookingUploadAgreementError: null,
        bookingUploadAgreementSuccess: null,
        bookingUploadAgreementLoading: true,
      };
    }

    case UPLOAD_BOOKING_AGREEMENT_SUCCESS: {


      const updatedActiveBookings = Array.isArray(state.activeBookings?.data)
        ? state.activeBookings.data.map((booking: any) =>
          booking.id === action.payload?.data?.id
            ? { ...booking, ...action.payload.data }
            : booking
        )
        : [];

      const updatedPendingBookings = Array.isArray(state.pendingBookings?.data)
        ? state.pendingBookings.data.map((booking: any) =>
          booking.id === action.payload?.data?.id
            ? { ...booking, ...action.payload.data }
            : booking
        )
        : [];


      return {
        ...state,
        bookingUploadAgreementSuccess: action.payload?.message,

        activeBookings: {
          ...(state.activeBookings ?? {}),
          data: updatedActiveBookings,
        },
        pendingBookings: {
          ...(state.pendingBookings ?? {}),
          data: updatedPendingBookings,
        },

        bookingDetail: action.payload?.data,
        bookingUploadAgreementLoading: false,
      };
    }

    case UPLOAD_BOOKING_AGREEMENT_FAILURE: {
      return {
        ...state,
        bookingUploadAgreementError: action.payload,
        bookingUploadAgreementLoading: false,
      };
    }

    // case GET_BOOKING_DATES: {
    //   return {
    //     ...state,
    //     bookingDates: [],
    //     bookingDatesError: null,
    //     bookingDatesLoading: true,
    //   };
    // }

    // case GET_BOOKING_DATES_SUCCESS: {
    //   return {
    //     ...state,
    //     bookingDates: action.payload,
    //     bookingDatesError: null,
    //     bookingDatesLoading: false,
    //   };
    // }

    // case GET_BOOKING_DATES_FAILURE: {
    //   return {
    //     ...state,
    //     bookingDatesError: action.payload,
    //     bookingDatesLoading: false,
    //   };
    // }

    case GET_PENDING_BOOKING: {
      return {
        ...state,
        pendingBookings: [],
        pendingBookingsError: null,
        pendingBookingsLoading: true,
      };
    }

    case GET_PENDING_BOOKING_SUCCESS: {
      return {
        ...state,
        pendingBookings: action.payload,
        pendingBookingsError: null,
        pendingBookingsLoading: false,
      };
    }

    case GET_FINAL_AGREEMENT_CHECKLIST: {
      return { ...state, finalAgreementChecklist: [] };
    }

    case GET_FINAL_AGREEMENT_CHECKLIST_SUCCESS: {
      return { ...state, finalAgreementChecklist: action.payload };
    }

    case GET_FINAL_AGREEMENT_CHECKLIST_FAILURE: {
      return { ...state };
    }





    case GET_CHECKIN_IMAGE: {
      return {
        ...state,
        checkInCarImages: [],
      };
    }

    case GET_CHECKIN_IMAGE_SUCCESS: {

      return {
        ...state,
        checkInCarImages: action.payload
      };
    }

    case GET_CHECKIN_IMAGE_FAILURE: {
      return {
        ...state,
      };
    }

    case UPLOAD_CHECKIN_IMAGE: {
      return {
        ...state,
        checkInCarImagesSuccess: null,
        checkInCarImagesError: null,
        checkInCarImagesLoading: true,

      };
    }

    case UPLOAD_CHECKIN_IMAGE_SUCCESS: {
      const updatedActiveBookings = Array.isArray(state.activeBookings?.data)
        ? state.activeBookings.data.map((booking: any) =>
          booking.id === action.payload?.data?.booking_id
            ? _.merge({}, booking, _.omit(action.payload.data, 'booking_id'))
            : booking
        )
        : [];

      const updatedPendingBookings = Array.isArray(state.pendingBookings?.data)
        ? state.pendingBookings.data.map((booking: any) =>
          booking.id === action.payload?.data?.booking_id
            ? _.merge({}, booking, _.omit(action.payload.data, 'booking_id'))
            : booking
        )
        : [];


      const updatedBookingDetail = state.bookingDetail.id === action.payload?.data?.booking_id
  ? _.merge({}, state.bookingDetail, _.omit(action.payload.data, 'booking_id'))
  : state.bookingDetail;

      return {
        ...state,
        bookingDetail: updatedBookingDetail,
        activeBookings: {
          ...(state.activeBookings ?? {}),
          data: updatedActiveBookings,
        },
        pendingBookings: {
          ...(state.pendingBookings ?? {}),
          data: updatedPendingBookings,
        },


        checkInCarImagesSuccess: action.payload.message,
        checkInCarImagesError: null,
        checkInCarImagesLoading: false,
      };
    }

    case UPLOAD_CHECKIN_IMAGE_FAILURE: {
      return {
        ...state,
        checkInCarImagesSuccess: null,
        checkInCarImagesError: action.payload,
        checkInCarImagesLoading: false,
      };
    }





    case GET_PROGRESS_MESSAGES: {
      return {
        ...state,
        progressMessages: [],

      };
    }

    case GET_PROGRESS_MESSAGES_SUCCESS: {


      return {
        ...state,
        progressMessages: action.payload.data,
      };
    }

    case GET_PROGRESS_MESSAGES_FAILURE: {
      return {
        ...state,
      };
    }







    case RESET_BOOKING_STATE: {
      return {
        ...state,

        pendingBookingsLoading: false,
        pendingBookingsError: null,
        bookingUploadLicenseSuccess: null,
        bookingUploadLicenseError: null,
        bookingUploadAgreementSuccess: null,
        bookingUploadAgreementError: null,

        bookingSelfieWithCarSuccess: null,
        bookingSelfieWithCarError: null,
        bookingUploadLicenseLoading: false,
        bookingUploadAgreementLoading: false,
        bookingSelfieWithCarLoading: false,

        bookingAddressProofSuccess: null,
        bookingAddressProofError: null,

        bookingAddressProofLoading: false,

        bookingCancelLoading: false,
        bookingsCalculateError: null,
        bookingCancelError: null,
        bookingCancelSuccess: null,

        checkInCarImagesSuccess: null,
        checkInCarImagesError: null,
        checkInCarImagesLoading: false,

        bookingsSuccess: null,
        bookingsError: null,
        bookingsLoading: false,

        extensionRequestLoading: false,
        extensionRequestSuccess: null,
        extensionRequestError: null,
        // extensionRequest: null,
      };
    }

    case CREATE_EXTENSION_REQUEST: {
      return {
        ...state,
        extensionRequestLoading: true,
        extensionRequestSuccess: null,
        extensionRequestError: null,
        extensionRequest: null,
      };
    }

    case CREATE_EXTENSION_REQUEST_SUCCESS: {
      return {
        ...state,
        extensionRequestLoading: false,
        extensionRequestSuccess: action.payload?.message,
        extensionRequestError: null,
        extensionRequest: action.payload?.data,
      };
    }

    case CREATE_EXTENSION_REQUEST_FAILURE: {
      return {
        ...state,
        extensionRequestLoading: false,
        extensionRequestSuccess: null,
        extensionRequestError: action.payload,
      };
    }

    default:
      return state;
  }
};
